// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as ZapDefault } from '../../../../../ui-v3/src/assets/icons/default/general/zap.svg?react';
import { ReactComponent as ZapSolid } from '../../../../../ui-v3/src/assets/icons/solid/general/ZAP.svg?react';
import { createIcons } from '../../Icon';
const ZapIcon = /* @__PURE__ */ createIcons('Zap', {
    default: ZapDefault,
    solid: ZapSolid
});
ZapIcon.supportedTypes = [
    'default',
    'solid'
];
ZapIcon.category = 'general';
export default ZapIcon;
